function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import "./MediaFigure.scss";

var MediaFigure = function (_Component) {
    _inherits(MediaFigure, _Component);

    function MediaFigure() {
        var _temp, _this, _ret;

        _classCallCheck(this, MediaFigure);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getClassNames = function () {
            var media = _this.props.media;
            var mediaType = media.mediaType;

            var classNames = [];

            classNames.push('preview');
            classNames.push('preview--' + mediaType);
            classNames = classNames.join(' ');

            return classNames;
        }, _this.renderPreview = function () {
            var _this$props = _this.props,
                uploadProgress = _this$props.uploadProgress,
                media = _this$props.media;
            var imageUrl = media.imageUrl,
                mediaType = media.mediaType,
                title = media.title;


            var classNames = _this.getClassNames();

            if (uploadProgress && uploadProgress < 100) {
                return React.createElement(
                    'figure',
                    { className: 'preview  preview--upload' },
                    React.createElement(
                        'h2',
                        { className: 'media__title' },
                        title
                    ),
                    React.createElement(
                        'p',
                        { className: 'media__descr' },
                        uploadProgress,
                        '/100'
                    )
                );
            }

            if (mediaType === "image") {
                return React.createElement(
                    'figure',
                    { className: classNames },
                    React.createElement('img', { src: imageUrl })
                );
            }

            return React.createElement(
                'figure',
                { className: classNames },
                React.createElement(
                    'h2',
                    { className: 'media__title' },
                    title
                ),
                React.createElement(
                    'p',
                    { className: 'media__descr' },
                    mediaType
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    MediaFigure.prototype.render = function render() {
        var _props = this.props,
            uploadProgress = _props.uploadProgress,
            media = _props.media,
            format = _props.format,
            settings = _props.settings;


        if (!media) {
            return false;
        }

        var style = {};

        if (uploadProgress) {
            var g = [];
            g[0] = "#ccc 0%";
            g[1] = "#ccc " + uploadProgress + "%";
            g[2] = "transparent " + uploadProgress + "%";
            g[3] = "transparent 100%";

            g = g.join(",");
            style = {
                backgroundImage: "linear-gradient(to top, " + g + ")"
            };
        }

        return React.createElement(
            'div',
            { className: 'admin-media__preview' },
            this.renderPreview()
        );
    };

    return MediaFigure;
}(Component);

export default MediaFigure;